import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { I18nProvider } from "@/contexts/I18nContext";
import { SiteSettingsProvider } from "@/contexts/SiteSettingsContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import Home from "@/pages/Home";
import Categories from "@/pages/Categories";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import SellerRegister from "@/pages/SellerRegister";
import SellerDashboard from "@/pages/SellerDashboard";
import BuyerDashboard from "@/pages/BuyerDashboard";
import OrderDetail from "@/pages/OrderDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Wishlist from "@/pages/Wishlist";
import AdminPanel from "@/pages/AdminPanel";
import CropAdvisor from "@/pages/CropAdvisor";
import Brands from "@/pages/Brands";
import BrandDetail from "@/pages/BrandDetail";

function App() {
  return (
    <HelmetProvider>
    <SiteSettingsProvider>
      <I18nProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/category/:slug" element={<Products />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/seller/register" element={<SellerRegister />} />
                  <Route path="/seller/dashboard" element={<SellerDashboard />} />
                  <Route path="/dashboard" element={<BuyerDashboard />} />
                  <Route path="/order/:id" element={<OrderDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/admin" element={<AdminPanel />} />
                  <Route path="/crop-advisor" element={<CropAdvisor />} />
                  <Route path="/brands" element={<Brands />} />
                  <Route path="/brand/:slug" element={<BrandDetail />} />
                </Routes>
              </main>
              <Footer />
              <Toaster position="top-right" richColors />
            </div>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </I18nProvider>
    </SiteSettingsProvider>
    </HelmetProvider>
  );
}

export default App;
